import * as userBusiness from "../business/user"
import * as taskBusiness from "../business/task"
import * as payBusiness from "../business/pay"
import * as luckydrawBusiness from "../business/luckydraw"
import * as configs from "../configs"

export default {
  getLoginState: context => userBusiness.getLoginState(context.userAgent),
  getZoneInfo: context => {
    return userBusiness.getWzryZones({
      loginState: context.loginState,
      userAgent: context.userAgent
    })
  },
  getUserZoneId: context => {
    return userBusiness.getUserZoneId({
      loginState: context.loginState,
      userAgent: context.userAgent,
      offerId: context.gameConfig.offerId
    })
  },
  getRoleInfo: context =>
    userBusiness.getRoleInfo({
      loginState: context.loginState,
      userAgent: context.userAgent,
      offerId: context.gameConfig.offerId,
      zoneid: context.selectedZoneId
    }),
  getTaskProgress: (context, event) =>
    taskBusiness.getTaskProgress({
      loginState: context.loginState,
      sandbox: context.sandbox,
      offerId: context.gameConfig.offerId,
      groupid: context.gameConfig.groupid,
      task_id: context.gameConfig.maps.find(item => item.level == (event.level || context.selectedMap)).task_id
    }),
  registerTask: context =>
    taskBusiness.batchRegisterTask({
      loginState: context.loginState,
      partitionInfo: context.partitionInfo,
      sandbox: context.sandbox,
      offerId: context.gameConfig.offerId,
      groupid: context.gameConfig.groupid,
      task_id_list: context.gameConfig.maps.map(item => item.task_id).join(",")
    }),
  placeOrder: context =>
    payBusiness.placeOrder({
      loginState: context.loginState,
      sandbox: context.sandbox,
      pf: context.pf,
      offerId: context.gameConfig.offerId,
      userAgent: context.userAgent,
      zoneid: context.partitionInfo.partition,
      gameId: `${context.partitionInfo.area}___${context.partitionInfo.partition}`,
      productId: context.purchaseInfo.product_id,
      productNum: 1,
      productName: context.purchaseInfo.name
    }),
  midasPay: (context, event) => {
    const groupid = context.gameConfig.products.find(draw => draw.product_id == context.purchaseInfo.product_id).groupid
    // if (context.userAgent.msdk) {
    //   return payBusiness.mobileSaveGoods({
    //     loginState: context.loginState,
    //     sandbox: context.sandbox,
    //     pf: context.pf,
    //     offerId: context.gameConfig.offerId,
    //     userAgent: context.userAgent,
    //     token_id: event.data.token,
    //     mid: event.data.mid,
    //     pay_method: "game_coin",
    //     // realPrice: context.gameConfig.products.find(draw => draw.rank == context.selectedPresentRank).price * 10,
    //     drm_info: `task_token=${context.taskInfo.task_token}&version=3.0&group_id=${groupid || ""}`
    //   })
    // } else {
    return payBusiness.midasPay({
      loginState: context.loginState,
      sandbox: context.sandbox,
      pf: context.pf,
      offerId: context.gameConfig.offerId,
      userAgent: context.userAgent,
      token: event.data.token,
      mid: event.data.mid,
      // realPrice: context.gameConfig.products.find(draw => draw.rank == context.selectedPresentRank).price * 10,
      drm_info: `task_token=${context.taskInfo.task_token}&version=3.0&group_id=${groupid || ""}`
    })
    // }
  },
  getTaskPresent: context => {
    const present_rank = context.availableReceivedRank[0]
    return taskBusiness.getTaskPresent({
      loginState: context.loginState,
      partitionInfo: context.partitionInfo,
      sandbox: context.sandbox,
      offerId: context.gameConfig.offerId,
      groupid: context.gameConfig.groupid,
      task_id: context.gameConfig.maps.find(item => item.level == context.selectedMap).task_id,
      present_rank: present_rank
    })
  },
  getLuckCoupon: context => {
    return luckydrawBusiness.getLuckCoupon({
      sandbox: context.sandbox,
      loginState: context.loginState,
      offerId: context.gameConfig.offerId,
      groupid: context.gameConfig.drawGroupid[context.selectedMap].find(draw => draw.rank == context.selectedPresentRank).groupid
    })
  },
  startDraw: (context, event) => {
    return luckydrawBusiness.startDraw({
      sandbox: context.sandbox,
      loginState: context.loginState,
      offerId: context.gameConfig.offerId,
      groupid: context.gameConfig.drawGroupid[context.selectedMap].find(draw => draw.rank == context.selectedPresentRank).groupid,
      game_platform_id: context.partitionInfo.game_platform_id,
      gameid: `${context.partitionInfo.area}___${context.partitionInfo.partition}`,
      code_id: event.data[0].code_id
    })
  },
  getLuckAward: (context, event) => {
    return luckydrawBusiness.getLuckAward({
      sandbox: context.sandbox,
      loginState: context.loginState,
      offerId: context.gameConfig.offerId,
      groupid: context.gameConfig.drawGroupid[context.selectedMap].find(draw => draw.rank == context.selectedPresentRank).groupid,
      curpage: event.curpage || 1
    })
  },
  //获取抽奖活动奖品列表
  getPrizeList: context => {
    const rank = context.prizeListRank

    return Promise.all([
      luckydrawBusiness.getPrizeList({
        sandbox: context.sandbox,
        loginState: context.loginState,
        offerId: context.gameConfig.offerId,
        groupid: context.gameConfig.drawGroupid[context.selectedMap].find(draw => draw.rank == rank).groupid
      }),
      luckydrawBusiness.getLuckAward({
        pagesize: configs.GAME_INFO.maxPrizeListPageSize,
        sandbox: context.sandbox,
        loginState: context.loginState,
        offerId: context.gameConfig.offerId,
        groupid: context.gameConfig.drawGroupid[context.selectedMap].find(draw => draw.rank == rank).groupid
      })
    ])
  },
  //系统繁忙倒计时
  busyCountDown: context => cb => {
    const interval = setInterval(() => {
      if (context.busyCount > 0) {
        cb("TICK")
        context.busyCount--
      } else {
        cb("STOP_COUNT")
      }
    }, 1000 * context.busyInterval)
    return () => {
      clearInterval(interval)
    }
  },
  getOpenlink: (context, event) => {
    return userBusiness.getOpenlink({
      offerId: context.gameConfig.offerId,
      url: event.url
    })
  },
  getAllTaskPresent: context => {
    return taskBusiness.getAllTaskPresent({
      sandbox: context.sandbox,
      loginState: context.loginState,
      offerId: context.gameConfig.offerId,
      partitionInfo: context.partitionInfo,
      task_id: context.gameConfig.maps.find(item => item.level == context.selectedMap).task_id,
      groupid: context.gameConfig.groupid
    })
  },
  getAllLuckCoupon: context => {
    return luckydrawBusiness.getAllLuckCoupon({
      sandbox: context.sandbox,
      loginState: context.loginState,
      offerId: context.gameConfig.offerId,
      sixCardId: configs.GAME_INFO.drawGroupid[context.selectedMap].filter(item => item.rank <= 6).map(item => item.groupid),
      cardidList: configs.GAME_INFO.drawGroupid[context.selectedMap]
        // .filter(item => item.rank <= 6)
        .map(item => item.groupid)
        .join(";")
    })
  },
  checkAllLuckCoupon: context => {
    return luckydrawBusiness.checkAllLuckCoupon({
      sandbox: context.sandbox,
      loginState: context.loginState,
      offerId: context.gameConfig.offerId,
      cardidList: configs.GAME_INFO.drawGroupid[context.selectedMap].map(item => item.groupid).join(";")
    })
  },
  // 查询用户参与任务的前置条件（是否对战）是否满足
  checkTaskPreCondition: (context, event) =>
    taskBusiness.checkTaskPreCondition({
      loginState: context.loginState,
      sandbox: context.sandbox,
      offerId: context.gameConfig.offerId,
      groupid: context.gameConfig.groupid,
      task_id: context.gameConfig.maps.find(item => item.level == (event.level || context.selectedMap)).task_id,
      task_token: context.taskInfo.task_token,
      partitionInfo: context.partitionInfo
    }),
  // 用户满足前置条件（是否对战）后可领取任务
  participateTask: (context, event) =>
    taskBusiness.participateTask({
      loginState: context.loginState,
      sandbox: context.sandbox,
      offerId: context.gameConfig.offerId,
      groupid: context.gameConfig.groupid,
      task_id: context.gameConfig.maps.find(item => item.level == (event.level || context.selectedMap)).task_id,
      task_token: context.taskInfo.task_token,
      partitionInfo: context.partitionInfo
    }),
  getUserInfoInGame: context =>
    userBusiness.getUserInfoInGame({
      loginState: context.loginState,
      sandbox: context.sandbox,
      offerId: context.gameConfig.offerId,
      gameid: `${context.partitionInfo.area}___${context.partitionInfo.partition}`,
      game_platform_id: context.partitionInfo.game_platform_id
    })
}
